<template>
  <div class="product-section" v-if="showPage">
    <div class="section-header">
      <div class="title-container">
        <h2 class="section-title config-nav-name" :data-id="id" data-type="products">
          {{ sectionTitle }}
        </h2>
        <!-- <p class="section-subtitle">发现优质好物，尽享购物乐趣</p> -->
      </div>
      <div class="more-action" v-show="isAllOrRecommend || (info.setting === 1 && info.settingStyle === 1)">
        <span class="lookmore" @click="lookMore(false)">查看更多 >></span>
      </div>
    </div>
    <div class="nav-box" v-if="info.setting === 1 && info.settingStyle === 1">
      <NavBar :list="info.areas" label="name" value="id" @change="changeNav"></NavBar>
    </div>
    <div class="products-container">
      <div
        class="products-grid"
        v-newloading="loading"
        v-if="isAllOrRecommend || (info.setting === 1 && info.settingStyle === 1)"
      >
        <template v-for="item in list">
          <div :key="item.uuid">
            <ProductOne @refresh="refreshList" :info="item"></ProductOne>
          </div>
        </template>
      </div>
      <template v-if="info.setting === 1 && info.settingStyle === 0">
        <div v-for="child in list" :key="child.id" class="panel-box">
          <div class="panel-header">
            <div class="panel-title">
              <div class="title-decoration"></div>
              <span>{{ child.name }}</span>
            </div>
            <div class="view-more cursor-pointer" @click="lookMore(child.id)">
              <span>查看更多</span>
              <i class="fas fa-chevron-right"></i>
            </div>
          </div>
          <div class="products-grid" v-newloading="loading">
            <template v-for="item in child.goodsList">
              <div :key="item.uuid">
                <ProductOne @refresh="refreshList" :info="item"></ProductOne>
              </div>
            </template>
          </div>
        </div>
      </template>
      <!-- 加载状态 -->
      <!-- <div v-if="loading" class="loading-container">
        <div class="loading-spinner"></div>
        <p>正在加载商品...</p>
      </div> -->
    </div>
  </div>
</template>

<script>
// import ProductOne from "@/views/newProducts/components/products/components/Product";
import { getGoodsList } from "@/api/goods";
import NavBar from "../common/NavBar";
export default {
  components: {
    // ProductOne: () => ({
    //   component: import("@/views/newProducts/components/products/components/Product"),
    //   loading: {
    //     template: '<div class="component-loading">加载中...</div>'
    //   },
    //   error: {
    //     template: '<div class="component-error">组件加载失败</div>'
    //   },
    //   timeout: 1000
    // }),
    ProductOne: () => import("@/views/newProducts/components/products/components/Product"),
    NavBar
  },
  props: {
    info: {
      type: Object,
      default: () => {}
    },
    id: {
      type: Number,
      default: 0
    }
  },
  computed: {
    // setting: 0全部零配件 / 1自定义 / 4推荐商品（按 modules.id 查）
    isAllOrRecommend() {
      return this.info && [0, 4].includes(Number(this.info.setting));
    },
    sectionTitle() {
      if (this.isAllOrRecommend) {
        return (this.info && this.info.title) || "推荐商品";
      }
      return (this.info && this.info.title) || "商品区";
    },
    showPage() {
      if (!this.info) return false;
      if (this.isAllOrRecommend) return this.listHasValue;
      return this.info.setting === 1 && this.info.areas && this.info.areas.length > 0;
    }
  },
  watch: {
    showPage: {
      handler(newV) {
        if (newV) {
          this.$nextTick(() => {
            this.$bus.$emit("resetLeftNav");
            if (this.isAllOrRecommend) {
              this.calculateCardsPerRow();
              this.getList();
            }
          });
        }
      },
      immediate: true
    },
    info: {
      handler(newV) {
        if (newV && newV.content) {
          this.$store.commit("goods/setNameRules", newV.content);
        }
        if ([0, 4].includes(Number(newV.setting))) {
          this.listHasValueFun();
        } else if (newV.setting === 1) {
          if (newV.settingStyle === 1) {
            if (newV.areas && newV.areas.length > 0) {
              this.chooseItem = newV.areas[0];
              this.getGoodsListByChooseItem();
            }
          }
          if (newV.settingStyle === 0 && newV.areas && newV.areas.length > 0) {
            this.getGoodsListLoop();
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      list: [],
      loading: false,
      chooseItem: null,
      pageSize: 12,
      listHasValue: false
    };
  },
  methods: {
    calculateCardsPerRow() {
      const container = this.$el.querySelector(".products-grid");
      if (!container) return;

      // 获取容器宽度
      this.containerWidth = container.clientWidth;

      // 卡片最小宽度 + 间隙
      const cardMinWidth = 230; // 对应 minmax(230px, 280fr)
      const gap = 2; // gap: 2px

      // 计算一行能容纳的卡片数量
      const availableWidth = this.containerWidth + gap; // 加上一个间隙
      this.cardsPerRow = Math.floor(availableWidth / (cardMinWidth + gap));

      // console.log(`容器宽度: ${this.containerWidth}px, 一行可容纳: ${this.cardsPerRow}个卡片`);
      this.pageSize = this.cardsPerRow * 2 || 12;
    },
    initResizeObserver() {
      const container = this.$el.querySelector(".products-grid");
      if (!container) return;

      this.resizeObserver = new ResizeObserver(entries => {
        for (const entry of entries) {
          this.calculateCardsPerRow();
        }
      });

      this.resizeObserver.observe(container);
    },
    /** setting=4 推荐商品：search 必须带 modules 级 moduleId */
    buildGoodsQuery(pageSize) {
      const params = { page: 1, pageSize };
      if (Number(this.info.setting) === 4) {
        params.moduleId = this.info.id;
      }
      params.paginationMode = 1;
      return params;
    },
    refreshList() {
      if (this.isAllOrRecommend) {
        this.getList();
      } else {
        if (this.info.settingStyle === 1) {
          this.getGoodsListByChooseItem();
        }
        if (this.info.settingStyle === 0) {
          this.getGoodsListLoop();
        }
      }
    },
    lookMore(id) {
      const params = {
        keyword: "",
        type: -2
      };
      // 推荐商品：列表页继续按 moduleId 过滤
      if (Number(this.info.setting) === 4) {
        params.moduleId = this.info.id;
      }
      if (this.chooseItem || id) {
        if (this.info.settingStyle === 1) {
          params.areaId = this.chooseItem.id;
          params.type = -1;
        }
        if (this.info.settingStyle === 0) {
          params.areaId = id;
          params.type = -1;
        }
      }
      this.$store.commit("search/setSearchData", params);
      this.$router.push({ path: "/new-products/product-list" });
    },
    changeNav(obj) {
      const item = this.info.areas.find(e => e.id === obj.item.id);
      if (item) {
        this.chooseItem = item;
        this.getGoodsListByChooseItem();
      } else {
        this.list = [];
      }
    },
    //循环获取商品
    async getGoodsListLoop() {
      this.loading = true;
      const list = [];
      for (let i = 0; i < this.info.areas.length; i++) {
        const chooseItem = this.info.areas[i];
        try {
          const res = await getGoodsList({
            page: 1,
            pageSize: chooseItem.showNumber,
            areaId: chooseItem.id,
            paginationMode: 1
          });
          list.push({
            name: chooseItem.name,
            id: chooseItem.id,
            goodsList: res.rows,
            showNumber: chooseItem.showNumber
          });
        } catch (error) {
          list.push({
            name: chooseItem.name,
            id: chooseItem.id,
            goodsList: [],
            showNumber: chooseItem.showNumber
          });
          console.error("获取商品列表失败:", error);
        }
      }
      this.list = list;
      this.loading = false;
    },
    async getGoodsListByChooseItem() {
      this.loading = true;
      try {
        const res = await getGoodsList({
          page: 1,
          pageSize: this.chooseItem.showNumber,
          areaId: this.chooseItem.id,
          paginationMode: 1
        });
        this.list = res.rows;
      } catch (error) {
        console.error(error.message || "获取商品失败");
        this.list = [];
      } finally {
        this.loading = false;
      }
    },
    //判断getList是否有值
    async listHasValueFun() {
      try {
        const res = await getGoodsList(this.buildGoodsQuery(1));
        this.listHasValue = res.rows && res.rows.length > 0;
      } catch (error) {
        this.listHasValue = false;
      }
    },
    async getList() {
      this.loading = true;
      try {
        const res = await getGoodsList(this.buildGoodsQuery(this.pageSize));
        this.list = res.rows || [];
      } catch (error) {
        this.list = [];
        console.error(error.message || "获取商品失败");
      } finally {
        this.loading = false;
      }
    }
  },
  mounted() {},
  created() {
    // this.getList();
  }
};
</script>

<style lang="scss" scoped>
.nav-box {
  margin-top: 12px;
  background: #fff;
  padding: 0 12px;
}
.product-section {
  margin: 8px 0;
  padding: 12px 4px;
  border-radius: 2px;
  background: #fff;
  // background: linear-gradient(145deg, #f8faff, #ffffff);
  // box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  // transition: all 0.3s ease;
  transition: box-shadow 0.3s ease;
  will-change: box-shadow;

  &:hover {
    // box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
  }
}
.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #eaeaea;

  .panel-title {
    display: flex;
    align-items: center;

    .title-decoration {
      width: 4px;
      height: 20px;
      background: linear-gradient(135deg, var(--color-light80), var(--color-primary-dark30));
      border-radius: 2px;
      margin-right: 10px;
    }

    span {
      font-size: 18px;
      font-weight: 600;
      color: #333;
    }
  }

  .view-more {
    display: flex;
    align-items: center;
    gap: 6px;
    color: var(--color-primary);
    font-size: 14px;
    font-weight: 500;
    transition: all 0.2s ease;

    &:hover {
      color: var(--color-primary-dark10);
      gap: 8px;
    }
  }
}
.panel-box {
  margin-bottom: 24px;
  border-bottom: 1px solid #eaeaea;
  padding-bottom: 12px;
}
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  // margin-bottom: 12px;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.title-container {
  .section-title {
    font-size: 20px;
    font-weight: 800;
    color: var(--color-primary);
    margin: 0 0 4px 0;
    padding-left: 12px;
    position: relative;

    &::after {
      content: "";
      position: absolute;
      bottom: -10px;
      left: 12px;
      width: 40px;
      height: 3px;
      background: linear-gradient(90deg, var(--color-light80), var(--color-primary-dark30));
      border-radius: 2px;
    }
  }

  .section-subtitle {
    font-size: 14px;
    color: #666;
    margin: 16px 0 0 0;
  }
}

.more-action {
  padding-right: 12px;
}

.products-container {
  background: #fff;
  padding: 12px;
  position: relative;
  // margin-top: 22px;
}

.products-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(230px, 280fr));
  // grid-template-columns: repeat(5, minmax(230px, 280fr));
  gap: 2px;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0;

  .loading-spinner {
    width: 40px;
    height: 40px;
    border: 3px solid rgba(79, 107, 255, 0.2);
    border-radius: 50%;
    border-top-color: var(--color-primary);
    animation: spin 1s linear infinite;
    margin-bottom: 12px;
  }

  p {
    color: #666;
    font-size: 14px;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .product-section {
    padding: 16px;
    margin: 16px 0;
  }

  .section-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .products-grid {
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    gap: 16px;
  }

  .section-title {
    font-size: 20px;
  }
}
</style>
